import styled from 'styled-components';

// content may be absolutely positioned so we do z-index: 2
export default styled.div`
  position: fixed;
  z-index: 2;
  background-color: white;
  width: 100%;
  left: 0;
`;
